<template>
  <confirm-dialog
    v-show="isShow"
    :data="dialogData"
    name="imagePickerModal"
    @confirm="handleConfirm"
  >
    <div class="image-picker-modal box">
      <croppa
        ref="croppaImage"
        :style="croppaStyle"
        :accept="acceptType"
        :placeholder="''"
        :file-size-limit="upload.MAX_FILE_SIZE_B"
        :width="width"
        :height="height"
        :show-remove-button="false"
        :replace-drop="true"
        :initial-image="thumbnailUrl"
        class="upload-box dropzone"
        @file-size-exceed="fileSizeExceed"
        @file-choose="handleFileChoose"
      >
        <div class="placeholder">
          <img :src="'/static/icons/button-add-cover.svg'" />
          <div>
            เพิ่มรูปภาพ
            <br />
            <br />(คลิก หรือลากไฟล์ลงในกรอบนี้)
          </div>
        </div>
        <img
          v-if="showRemoveImage"
          src="/static/icons/cancel-black.svg"
          class="btn-remove pointer"
          @click="removeFile"
        />
      </croppa>

      <div class="remake">
        * ขนาดที่แนะนำคือ {{ recommendWidth }} x {{ recommendHeight }} พิกเซล
        {{ additionalMessage }}และ ขนาดไฟล์สูงสุดคือ {{ upload.MAX_FILE_SIZE_MB }} MB
      </div>
    </div>
  </confirm-dialog>
</template>

<script>
import { UPLOAD } from "@/config/constant";

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    thumbnailFile: {
      type: [Object, File, Blob],
      default: null
    },
    thumbnailUrl: {
      type: String,
      default: ""
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 300
    },
    height: {
      type: [Number, String],
      default: 200
    },
    accept: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    recommendWidth: {
      type: [Number, String],
      default: 0
    },
    recommendHeight: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      file: null,
      fileChanged: false,
      upload: UPLOAD
    };
  },
  computed: {
    dialogData() {
      const buttonSubmit = this.isLoading ? "กำลังดำเนินการ" : "เลือก";
      return {
        title: this.title,
        buttonCancel: "ยกเลิก",
        buttonSubmit,
        disableSubmit: this.isLoading || !this.fileChanged,
        disableCancel: this.isLoading,
        hideAction: !this.canEdit
      };
    },
    initialImage() {
      if (!this.thumbnailFile && !this.thumbnailUrl) {
        return null;
      }

      if (this.thumbnailFile) {
        return this.thumbnailFile;
      }

      return this.thumbnailUrl;
    },
    showRemoveImage() {
      return this.initialImage || this.fileChanged;
    },
    croppaStyle() {
      return { width: `${this.width}px`, height: `${this.height}px` };
    },
    acceptType() {
      return this.accept ? this.accept : "image/*";
    },
    additionalMessage() {
      return this.message ? this.message : "";
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        this.$refs.croppaImage.refresh();
      }
    }
  },
  methods: {
    async handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.$emit("cancel");
        this.removeFile();
        return;
      }

      if (!this.fileChanged) {
        this.$emit("cancel");
        return;
      }

      const blob = await this.$refs.croppaImage.promisedBlob();

      this.$emit("confirm", blob);
      this.fileChanged = false;

    },
    handleFileChoose(file) {
      this.file = file;
      this.fileChanged = true;
    },
    hasImage() {
      if (!this.$refs.croppaImage) {
        return false;
      }

      return this.$refs.croppaImage.hasImage();
    },
    fileSizeExceed() {
      this.fileChanged = false;
      this.$message.error(
        `${this.$t("feature.upload.exceed_max_file_size")} ${
          UPLOAD.MAX_FILE_SIZE_MB
        } MB`
      );
    },
    removeFile() {
      this.fileChanged = false;
      this.$refs.croppaImage.remove();
    }
  }
};
</script>

<style lang="scss" scoped>
.image-picker-modal {
  .upload-box {
    position: relative;
    box-sizing: content-box;
    border: 2px dashed #d8d6d9;
    cursor: pointer;

    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #8c8786;
    object-fit: thumbnail;

    margin: 0 auto;

    &.croppa--has-target {
      .placeholder {
        display: none;
      }
    }
  }
  .input-file {
    opacity: 0; /* invisible but it's there! */
    left: 0;
    width: 360px;
    height: 154px;
    position: absolute;
    cursor: pointer;
    z-index: 99;
  }
  .btn-remove {
    position: absolute;
    width: 25px;
    height: 25px;
    top: -10px;
    right: -10px;
    z-index: 3;
  }
  .show-file {
    width: 360px;
    height: 154px;
  }
  .remake {
    font-size: 11px;
    font-weight: normal;
    line-height: 1.64;
    letter-spacing: -0.1px;
    color: #8c8786;
    margin-top: 16px;
    text-align: center;
  }

  .placeholder {
    z-index: 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    pointer-events: none;
    user-select: none;
    pointer-events: none;
  }
  .upload-box.croppa--has-target .placeholder {
    display: none;
  }
}
</style>
